import { ChangeDetectionStrategy, Component, inject } from "@angular/core";
import { toSignal } from "@angular/core/rxjs-interop";
import { RouterLink } from "@angular/router";
import { CampaignType, M19Status } from "@front/m19-api-client";
import { AccountMarketplaceService, AccountSelectionService, DspBidderIssueService } from "@front/m19-services";
import { IAlertComponent, ToasterService } from "@front/m19-ui";
import { TranslocoDirective, TranslocoService } from "@jsverse/transloco";
import { LoadingService } from "@m19-board/services/loading.service";
import { StrategyListComponent } from "@m19-board/strategies/strategy-list/strategy-list.component";
import { catchError, of, switchMap } from "rxjs";
import { map, tap } from "rxjs/operators";

@Component({
  selector: "app-dsp-manager",
  imports: [StrategyListComponent, IAlertComponent, TranslocoDirective, RouterLink],
  templateUrl: "./dsp-manager.component.html",
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DspManagerComponent {
  private readonly accountSelectionService = inject(AccountSelectionService);
  private readonly accountMarketplaceService = inject(AccountMarketplaceService);
  private readonly toastrService = inject(ToasterService);
  private readonly translocoService = inject(TranslocoService);
  private readonly loadingService = inject(LoadingService);
  private readonly dspBidderIssueService = inject(DspBidderIssueService);
  protected readonly CampaignType = CampaignType;

  readonly organizationId = toSignal(
    this.accountSelectionService.singleAccountMarketplaceSelection$.pipe(
      map((accountMarketplace) => accountMarketplace.resourceOrganizationId),
    ),
  );
  readonly dspAdvertiser = toSignal(
    this.accountSelectionService.singleAccountMarketplaceSelection$.pipe(
      tap(() => this.loadingService.loadingOn()),
      switchMap((accountMarketplace) => {
        if (accountMarketplace.dspAdvertiserId) {
          return this.accountMarketplaceService.getDspAdvertiser(accountMarketplace.dspAdvertiserId).pipe(
            catchError((error) => {
              this.toastrService.error(this.translocoService.translate("dsp-stats.error_loading_dsp_advertiser"));
              return of(undefined);
            }),
          );
        }
        return of(undefined);
      }),
      tap(() => this.loadingService.loadingOff()),
    ),
  );
  readonly dspAdvertiserIsNotApproved = toSignal(
    this.dspBidderIssueService.dspBidderIssues$.pipe(
      map((issues) => issues.some((issue) => issue.status === M19Status.ADVERTISER_NOT_APPROVED)),
    ),
  );
}
